import React, { Fragment, useMemo } from "react";
import Logo from "../printtest/components/Logo";
import Title from "../printtest/components/Title";
import PrintText from "../printtest/components/PrintText";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import PrintController from "../printtest/PrintController";
import Hr from "../printtest/components/Hr";
import { setPresPrintaction } from "../../../../redux/printstate/printActions";
import LetterHead from "../printtest/components/LetterHead";
import PrintSettingsShell from "../printtest/PrintSettingsShell";

function PrePrint({ viewsetting }: any) {
  const { printPosition, clinic, patient, prescriptionData } = useSelector(
    (state: RootState) => state.preprint
  );

  const date = useMemo(
    () => new Date(patient?.createdAt ?? ""),
    [patient?.createdAt]
  );

  const currentTime = useMemo(() => date.toLocaleTimeString(), [date]);

  const preview = (
    <>
      <div
        style={{
          background: "white",
          width: "100%",
          height: "auto",
        }}
        className="billtext"
      >
        <div
          style={{
            border: printPosition?.container?.show ? "1px solid black" : 0,
            width: printPosition?.container?.left,
            overflow: "hidden",
            padding: 10,
            position: "relative",
            height: printPosition?.container?.top,
            background: "white",
          }}
        >
          {printPosition?.logo?.show && (
            <Logo item={printPosition?.logo} src={clinic?.printImages} />
          )}
            {printPosition?.footerImage?.show  && (
              <LetterHead
                item={printPosition?.footerImage}
                src={clinic?.footerImages}
              />
            )}
            {printPosition?.headerImage?.show  && (
              <LetterHead
                item={printPosition?.headerImage}
                src={clinic?.headerImages}
              />
            )}
          <Title item={printPosition?.header} clinicName={clinic?.clinicName} />

          <PrintText item={printPosition?.datetimetext} title={"Date/Time"} />
          <PrintText
            item={printPosition?.datetime}
            title={currentTime + "|" + date?.toLocaleDateString("en-GB")}
          />

          <PrintText
            item={printPosition?.patientNametext}
            title={"Patient Name"}
          />
          <PrintText
            item={printPosition?.patientName}
            title={patient?.fullName}
          />

          <PrintText item={printPosition?.gendertext} title={"Gender"} />
          <PrintText item={printPosition?.gender} title={patient?.gender} />
          <Hr item={printPosition?.horizontallineone} />
          <table
            className="treatmentbill"
            style={{
              position: "absolute",
              top: printPosition?.treatmentDetail?.top,
              left: printPosition?.treatmentDetail?.left,
              width: printPosition?.treatmentDetail?.size,
              display: printPosition?.treatmentDetail?.show ? "" : "none",
            }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>No</th>
                <th style={{ textAlign: "center" }}>Drugs</th>
                <th style={{ textAlign: "center" }}>Dose</th>
                <th style={{ textAlign: "center" }}>Frequency</th>
                <th style={{ textAlign: "end" }}>Duration</th>
              </tr>
            </thead>
            <tbody>
              {prescriptionData?.map((items: any, i: number) => (
                <Fragment key={i}>
                  <tr key={i}>
                    <td style={{ width: 40, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ textAlign: "center" }}>{items?.drugs}</td>
                    <td style={{ textAlign: "center" }}>{items?.dose}</td>
                    <td style={{ textAlign: "center" }}>{items?.frequency}</td>
                    <td style={{ textAlign: "end" }}>{items?.duration}</td>
                  </tr>
                </Fragment>
              ))}
            </tbody>
          </table>
          <div className="dots"></div>

          <Hr item={printPosition?.horizontallinetwo} />
          <PrintText item={printPosition?.addresstext} title={"address :"} />
          <PrintText item={printPosition?.address} title={clinic?.address} />
          <PrintText item={printPosition?.teltext} title={"Tel :"} />
          <PrintText item={printPosition?.tel} title={clinic?.tpNo} />
          <PrintText
            item={printPosition?.dentisttext}
            title={"Dental Surgeon :"}
          />
          <PrintText item={printPosition?.dentist} title={clinic?.drName} />
        </div>
      </div>
    </>
  );

  return viewsetting ? (
    <PrintSettingsShell
      preview={preview}
      previewLabel="Prescription Preview"
      controls={
        <PrintController
          item={printPosition}
          api={"/clinic/addPreData"}
          action={setPresPrintaction}
        />
      }
    />
  ) : (
    preview
  );
}

export default PrePrint;
